import { ajax as request } from '@blade/common';
export var TASK_TYPE;
(function (TASK_TYPE) {
    TASK_TYPE[TASK_TYPE["WARN"] = 1] = "WARN";
    TASK_TYPE[TASK_TYPE["PASS"] = 2] = "PASS";
    TASK_TYPE[TASK_TYPE["DEVICE"] = 3] = "DEVICE";
    TASK_TYPE[TASK_TYPE["FACE"] = 4] = "FACE";
    TASK_TYPE[TASK_TYPE["LOGIN_LOG"] = 5] = "LOGIN_LOG";
    TASK_TYPE[TASK_TYPE["OPERATE_LOG"] = 6] = "OPERATE_LOG";
})(TASK_TYPE || (TASK_TYPE = {}));
export const exportTarget = async (param, taskType) => {
    const resp = await request({
        url: `/api/portrait-management/api/v1/feature/batch/export`,
        // url: `/api/v1/batchTask/export`,
        method: 'POST',
        data: { portraitIds: param.portraitIds, libraryType: taskType },
        // headers: { responseType: 'blob' }
    });
    if (resp?.data?.data) {
        // var alink = document.createElement('a');
        // alink.download = resp.headers.filename || `${new Date().getTime()}`;
        // alink.style.display = 'none';
        // console.log(resp.data);
        // // var blob = new Blob([resp.data]);
        // const blob = new Blob(['\ufeff' + resp.data], { type: 'text/csv,charset=UTF-8' });
        // //const url = window.URL.createObjectURL(resp.data);
        // alink.href = URL.createObjectURL(blob);
        // document.body.appendChild(alink);
        // alink.click();
        // document.body.removeChild(alink);
        // console.log(`http://bj.cluster41.xplorer.sensetime.com${resp.data.data}`, 444444);
        // window.location.href = process.env.NODE_ENV==='development'? `http://bj.cluster21.xplorer.sensetime.com${resp.data.data}`:`${window.location.host}${resp.data.data}`;
    }
    return resp;
};
export const exportWarn = async (param, taskType) => {
    const resp = await request({
        url: `/api/crowd-record-management/api/v1/crowd/export`,
        method: 'POST',
        data: { ...param, alertType: taskType },
    });
    // if (resp?.data?.data) {
    //   window.location.href = process.env.NODE_ENV === 'development' ? `http://10.8.10.29:31234/${resp.data.data}` : resp.data.data;
    // }
    return resp;
};
export const exportLog = async (param, taskType) => {
    const resp = await request({
        url: `/api/user-management/api/v1/log/export`,
        method: 'POST',
        data: param,
    });
    // if (resp?.data?.data) {
    //   console.log(resp.data.data);
    //   window.location.href = process.env.NODE_ENV === 'development' ? `http://10.8.10.29:31234${resp.data.data}` : resp.data.data;
    // }
    return resp;
};
export const exportPass = async (param) => {
    const resp = await request({
        url: `/api/access-management/api/v1/pass/export`,
        method: 'POST',
        data: param,
    });
    return resp;
};
